import gql from 'graphql-tag';

export const calendarQuery = gql`
  query getEventOccurrences($today: String) {
    eventOccurrences(first: 1000, where: { dateStart: $today }) {
      nodes {
        end {
          day
          isoDate
          meridiem
          month
          time
          timestamp
          timezone
          year
          weekday
        }
        eventSlug
        eventTypes {
          nodes {
            name
            slug
          }
        }
        excerpt
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        imageSrcset
        hideStartTime
        multisession
        soldOutLabel
        specificImage {
          altText
          imageSrcset
          sourceUrl
        }
        specificText
        start {
          day
          isoDate
          meridiem
          month
          time
          timestamp
          timezone
          year
          weekday
        }
        title
        ticketLabel
        ticketLink
        timezoneAbbr
      }
      pageInfo {
        hasMoreEventOccurrences
      }
    }
  }
`;
